import { MRT_ColumnDef, MRT_DisplayColumnIds } from "material-react-table"

export const COLUMN_SIZE = {
    XXS: 30, // Extra small, useful for action icons or status indicators
    XS: 60, // Smallest useful text column, e.g., for IDs
    SS: 90, // A bit bigger size of column then sx for specific cases
    S: 120, // Suitable for short text fields
    SM: 160, // Small to medium range, useful for names or small descriptions
    SMM: 190, // Medium range. Added in case we have long titles
    M: 220, // Medium, good for longer names, dates, or numeric values
    ML: 280, // Medium-large, for descriptions or formatted content
    L: 350, // Large, good for wider text columns like addresses
    XL: 500, // Extra-large, useful for long descriptions or detailed info
    XXL: 700, // Extra-extra-large, useful for large text blocks or logs
    XXXL: 2000, // Extra-extra-large, useful for large text blocks or logs
}

export const defaultDisplayColumnDefOptions: Partial<{
    [key in MRT_DisplayColumnIds]: Partial<MRT_ColumnDef>
}> = {
    "mrt-row-actions": {
        header: "",
        size: COLUMN_SIZE.XS,
        maxSize: COLUMN_SIZE.XS,
        muiTableBodyCellProps: {
            align: "center",
        },
    },
    "mrt-row-expand": {
        header: "",
        size: COLUMN_SIZE.XS,
        maxSize: COLUMN_SIZE.XS,
        muiTableHeadCellProps: {
            style: {
                padding: "0",
                border: "none",
            },
        },
        muiTableBodyCellProps: {
            align: "center",
            style: {
                padding: "0",
            },
        },
    },
}

export type ColumnConfig<TData extends Record<string, any>> = Partial<MRT_ColumnDef<TData>>

export const filterColumnConfig: ColumnConfig<any> = {
    filterVariant: "select",
    muiTableHeadCellProps: {
        align: "center",
    },
    size: COLUMN_SIZE.S,
    muiTableBodyCellProps: {
        align: "center",
        style: {
            verticalAlign: "baseline",
        },
    },
}

export const columnConfigAlignCenter: ColumnConfig<any> = {
    muiTableHeadCellProps: {
        align: "center",
    },
    muiTableBodyCellProps: {
        align: "center",
    },
}

export const columnConfigAlignEnd: ColumnConfig<any> = {
    muiTableHeadCellProps: {
        align: "right",
    },
    muiTableBodyCellProps: {
        align: "right",
    },
}
